<span class="version">LLFE Manager v{{version}}</span>